var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKitchenEssentials(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 34,
    viewBox: "0 0 32 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3846 13.4444H5.84615C5.35652 13.4444 4.88695 13.2571 4.54073 12.9237C4.19451 12.5903 4 12.1382 4 11.6667V4.55556C4 4.08406 4.19451 3.63188 4.54073 3.29848C4.88695 2.96508 5.35652 2.77778 5.84615 2.77778H25.7883C26.0588 2.77774 26.3259 2.83492 26.5709 2.94528C26.8159 3.05564 27.0327 3.21648 27.206 3.41643C27.3792 3.61637 27.5048 3.85054 27.5738 4.10237C27.6427 4.35421 27.6533 4.61755 27.6049 4.87378L24.3077 22.3333M9.53846 2.77778L13.2308 22.3333M16.9231 2.77778V1H20.6154V2.77778M18.7692 27.6667V27.6844M15.0769 22.3333H22.4615C23.9304 22.3333 25.3392 22.8952 26.3778 23.8954C27.4165 24.8956 28 26.2522 28 27.6667V31.2222C28 31.6937 27.8055 32.1459 27.4593 32.4793C27.1131 32.8127 26.6435 33 26.1538 33H11.3846C10.895 33 10.4254 32.8127 10.0792 32.4793C9.73297 32.1459 9.53846 31.6937 9.53846 31.2222V27.6667C9.53846 26.2522 10.122 24.8956 11.1606 23.8954C12.1993 22.8952 13.608 22.3333 15.0769 22.3333Z",
    stroke: "var(--brand-color)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKitchenEssentials);
export default __webpack_public_path__ + "static/media/kitchen_essentials.32658ed36a00bf67417a92811b69bde9.svg";
export { ForwardRef as ReactComponent };